import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Spinner from './Spinner'

interface ProgressCardProps {
  title: string;
  isLoading: boolean;
  progressValue: number;
  tooltipText?: string;
  onClick?: () => void;
  compact?: boolean;
}

const ProgressCard: React.FC<ProgressCardProps> = ({
  title,
  isLoading,
  progressValue,
  tooltipText,
  onClick,
  compact = false,
}) => {

  if (compact) {
    return (
      <div
        onClick={() => onClick && onClick()}
        className="progress-card-compact cursor-pointer"
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <div className="progress-card-compact__ring">
              <CircularProgressbar
                value={progressValue || 0}
                text={`${progressValue || 0}%`}
                styles={buildStyles({
                  textColor: '#3F4254',
                  pathColor: '#F53B6E',
                  trailColor: '#EEF6FF',
                  textSize: '28px',
                })}
              />
            </div>
            <div className="progress-card-compact__label">{title}</div>
          </>
        )}
      </div>
    );
  }

  return (
    <OverlayTrigger
      placement="bottom"
      delay={{ show: 250, hide: 400 }}
      overlay={<Tooltip id="tooltip-bottom">{tooltipText}</Tooltip>}
    >
      <div onClick={() => onClick && onClick()} className="card mt-5 w-163px h-205px px-10 py-10 align-items-start justify-content-between circle-progress cursor-pointer">
        <div className="box mb-2">
          <div
            className="title circle-progress"
            style={{ whiteSpace: 'nowrap' }}
          >
            {title}
          </div>
        </div>
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="box">
            <div style={{ width: 100, height: 100 }}>
              <CircularProgressbar
                value={progressValue || 0}
                text={`${progressValue || 0}%`}
                styles={buildStyles({
                  textColor: '#3F4254',
                  pathColor: '#F53B6E',
                  trailColor: '#EEF6FF',
                })}
              />
            </div>
            <div className="bottom">
              <div className="left">{progressValue || 0}</div>
            </div>
          </div>
        )}
      </div>
    </OverlayTrigger>
  );
};

export default ProgressCard;
